import { render } from "./SellersView.vue?vue&type=template&id=e4acac7a&scoped=true"
import script from "./SellersView.vue?vue&type=script&lang=js"
export * from "./SellersView.vue?vue&type=script&lang=js"

import "./SellersView.vue?vue&type=style&index=0&id=e4acac7a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e4acac7a"]])

export default __exports__